import React from 'react';
import { css } from '@emotion/core';
import './AboutUs.scss';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';
import { isColorLight } from '../../../../utils/colors';

const AboutUs = ({
  aboutUsVersion,
  primaryColor,
  secondaryColor,
  aboutUsDetails,
  isMobile,
}) => {
  const isPrimaryColorLight = isColorLight(primaryColor);
  const isSecondaryColorLight = isColorLight(secondaryColor);

  const aboutUsStyle = css`
    &.version-1 {
      padding-right: 3% !important;
      padding-left: 3% !important;
      @media screen and (max-width: 567px) {
        flex-direction: column;
        gap: 5px;
      }
      .about-left-box {
        @media screen and (min-width: 992px) {
          max-height: 54vh;
        }
        border: 2px solid ${secondaryColor};
        .text-variant {
          color: #333;
          h2 {
            color: #333;
          }
          span {
            color: #333;
          }
          div {
            @media screen and (min-width: 1200px) and (max-width: 1350px) {
              display: -webkit-box;
              -webkit-line-clamp: 6;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
            @media screen and (min-width: 768px) {
              font-size: 12px;
            }
            h2 {
              max-width: 470px;
            }
          }
        }
      }
      .about-right-box {
        @media screen and (min-width: 992px) {
          max-height: 54vh;
        }
        .image-variant {
          height: 100%;
          img {
            @media screen and (max-width: 567px) {
              max-height: 24vh;
            }

            object-fit: cover;
          }
        }
      }
    }
    &.version-2 {
      padding: 24px 60px !important;

      @media screen and (max-width: 992px) {
        padding: 20px !important;
      }

      @media screen and (max-width: 992px) {
        flex-direction: column-reverse;
        gap: 10px;
        height: unset;
      }

      @media screen and (min-width: 993px) {
        gap: 70px;
      }

      background-color: ${secondaryColor};
      border-radius: 6px;
      align-items: center;
      justify-content: space-between;
      gap: 3px;

      .about-left-box {
        align-self: center;
        .text-variant h2 {
          color: #fff;
          font-size: 40px;
          line-height: 42px;
          @media screen and (max-width: 992px) {
            font-size: 22px;
            line-height: 25px;
          }
        }
      }

      .about-left-box,
      .about-right-box {
        border: none;
        background-color: transparent;
        color: #fff;
        display: flex;
        justify-content: center;
      }

      .about-right-box {
        justify-content: center;
        .image-variant {
          @media screen and (min-width: 1201px) {
            padding: 0;
          }
          @media screen and (min-width: 992px) and (max-width: 1200px) {
            padding: 0;
          }
          @media screen and (max-width: 992px) {
            padding-top: 0;
          }

          img {
            max-width: 480px;
            max-height: 480px;
            min-height: unset;
            border-radius: 50%;
            aspect-ratio: 1 / 1;

            @media screen and (max-width: 567px) {
              padding: 15px;
              max-width: 100%;
              max-height: 100%;
            }
            @media screen and (min-width: 568px) and (max-width: 1400px) {
              padding: 15px;
              max-width: 400px;
              max-height: 400px;
            }
          }
        }
      }

      .about-left-box {
        .text-variant {
          padding: 22px;
          @media screen and (min-width: 993px) {
            padding: 0;
          }
          @media screen and (min-width: 568px) and (max-width: 992px) {
            padding: 40px;
          }
          & div {
            font-size: 14px;
            @media screen and (min-width: 768px) {
              font-size: 12px;
            }
            @media screen and (max-width: 370px) {
              text-align: left;
            }
            @media screen and (max-width: 992px) {
              max-width: unset;
            }
          }
        }
        .text-variant {
          color: ${isSecondaryColorLight ? '#333' : '#f9f9f9'} !important;
          h2 {
            color: ${isSecondaryColorLight ? '#333' : '#f9f9f9'} !important;
          }
          span {
            color: ${isSecondaryColorLight ? '#333' : '#f9f9f9'} !important;
          }
        }
      }
    }

    &.version-3 {
      @media screen and (max-width: 768px) {
        flex-direction: column;
        gap: 5px;
        padding: 0 !important;
        row-gap: 2rem;
      }
      .about-left-box {
        background-color: ${primaryColor};
        .text-variant {
          color: ${isPrimaryColorLight ? '#333' : '#f9f9f9'} !important;
          h2 {
            color: ${isPrimaryColorLight ? '#333' : '#f9f9f9'} !important;
          }
          span {
            color: ${isPrimaryColorLight ? '#333' : '#f9f9f9'} !important;
          }
        }
      }
      .about-right-box {
        border: 2px solid ${primaryColor};
        .text-variant {
          color: #333;
          h2 {
            color: #333;
          }
          span {
            color: #333;
          }
        }
      }
    }
  `;

  return (
    <div className={`container version-${aboutUsVersion}`} css={aboutUsStyle}>
      <div id="about-left-box" className="about-left-box">
        <div className="text-variant">
          <h2>{aboutUsDetails.title}</h2>
          <div
            dangerouslySetInnerHTML={{ __html: aboutUsDetails.description }}
          />
        </div>
      </div>
      <div className="about-right-box">
        {aboutUsVersion !== 3 && !isMobile && (
          <div className="image-variant">
            <ImageDispatcher
              alt="Immagine rappresentativa della sezione Chi Siamo"
              src={aboutUsDetails.image}
            />
          </div>
        )}
        {aboutUsVersion === 3 && (
          <div className="text-variant">
            <h2>{aboutUsDetails.box2Title}</h2>
            <div
              dangerouslySetInnerHTML={{ __html: aboutUsDetails.box2Text }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AboutUs;
//aboutUsVersion 1: 2 containers with flex-basis 50%: the first one filled with text, the second filled with an image;
//aboutUsVersion 2: 2 unified containers: the first one  filled with text, the second one contains a centered image within a rounded 50% container
//aboutUsVersion 3: 2 containers with flex-basis 50%: the first one filled with text, the second filled with another text;
